import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=08f3d46c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=08f3d46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f3d46c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f3d46c')) {
      api.createRecord('08f3d46c', component.options)
    } else {
      api.reload('08f3d46c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=08f3d46c&scoped=true&", function () {
      api.rerender('08f3d46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GZ57B9oWzZAL/JS/comp/Voucher.vue"
export default component.exports